import { sendRequest } from "../../../lib-alme-request/src/lib-alme-request";
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {Dictionary} from "../../../../types/rendering";
import LiveChatState from "../livechat-state";


export default class InputBoxButtonLiveChatMutator
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;


    //#region Public Interface
    
    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    getMutator()
    {
        return (parameters: Dictionary): Dictionary =>
        {
            const newParams = { ...parameters };

            if (this._stateManager.isOnline)
            {
                newParams.onclick = (e: Event): void =>
                {
                    if(this._settings.livechat.allowEmptyTypingEvent){
                        const input = {
                            messageType: this._settings.messageConstants.reportingEventRequest,
                            eventName: this._settings.livechat.reportingEventConstants.userTypingEventName,
                            eventValue: "",
                        };
                        sendRequest(input);
                    }

                    //execute any original handler
                    if (parameters.onclick) { (parameters.onclick as (event: Event) => void)(e); }
                };
            }

            return newParams;
        };
    }
    
    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/inputbox-button-mutator.ts